// extracted by mini-css-extract-plugin
module.exports = {"chatPage":"Chat_chatPage__1BRsU","form-control":"Chat_form-control__TMNbX"};